<template>
  <!-- 头部 -->
  <div class="header-wrap">
    <div
      class="specialistHeader"
      :style="{ background: background }"
      :class="{ active: searchShow }"
    >
      <img
        class="specialistHeader_img"
        src="@/assets/image/index/huanjingLOGO.png"
        alt
        v-show="!searchShow"
        @click="goHome"
      />
      <div
	  	class="hoverBorder"
        :class="{ active: toggle == index }"
        v-for="(item, index) in headList"
        :key="index"
        v-show="!searchShow"
      >
        <a @click="goTo(item.path)">{{ item.name }}</a>
      </div>
      <div @click="goToResult" v-show="!searchShow" class="hoverBorder">
        <i class="el-icon-search"></i>
        <span>搜索</span>
      </div>
      <!-- <div v-if="!searchShow && !$store.getters.token">
        <a @click="login" class="login">登录</a>
        <a @click="register">注册</a>
      </div> -->
      <!-- <div v-if="!searchShow && $store.getters.token">
        <span @click.stop="$store.commit('editPwd', 2)">{{
          $store.getters.userInfo.nickName
        }}</span>
        | <span @click.stop="$store.commit('editPwd', 1)">修改密码</span> |
        <span @click="signOut">退出</span>
      </div> -->
      <div class="search" v-if="searchShow">
        <div class="search-wrap">
          <img
            class="search-img"
            src="@/assets/image/index/close.png"
            alt
            @click="back"
          />
          <el-input
            placeholder="请输入您要搜索的内容"
            v-model="name"
            @keyup.enter.native="sendValue"
          >
          </el-input>
          <img
            class="search-img"
            src="@/assets/image/index/search.png"
            alt
            @click="sendValue"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "headTop",
  props: {
    toggle: {
      type: Number,
      default: 0,
    },
    background: {
      type: String,
      default: "#2579bf",
    },
    searchShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headList: [
        { name: "首页", path: "/" },
        { name: "关于我们", path: "/aboutUs" },
        // { name: "技术装备", path: "/equipment" },
        // { name: "产品与服务", path: "/case" },
        { name: "产品与案例", path: "/case" },
        { name: "企业展馆", path: "/enterprise" },
        { name: "常用业务", path: "/common" },
        { name: "云课堂", path: "/cloudClassroom" },
        
      ],
      name: "",
    };
  },
  mounted() {
    if (!this.$store.getters.token && sessionStorage.getItem("token")) {
      this.$store.commit("setToken", sessionStorage.getItem("token"));
    }
    if (sessionStorage.getItem("userInfo")) {
      this.$store.commit(
        "userInfo",
        JSON.parse(sessionStorage.getItem("userInfo"))
      );
    }
  },
  methods: {
    goTo(path) {
      this.$router.push({
        path,
      });
    },
    goToResult() {
      this.$router.push({
        path: "/index/searchResult",
      });
    },
    goHome() {
      this.$router.push({
        path: "/",
      });
    },
    sendValue() {
      this.$emit("name", this.name);
    },
    back() {
      this.$router.go(-1);
    },
    login() {
      this.$store.commit("changeDialog", true);
      this.$store.commit("changeToggle", 1);
    },
    register() {
      this.$store.commit("changeDialog", true);
      this.$store.commit("changeToggle", 2);
    },
    signOut() {
      // 退出
      this.$confirm("是否确认退出?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.$store.dispatch("getToken", "");
          this.$store.dispatch("getUserInfo", "");
          this.$store.dispatch("getUserDeptInfo", "");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("userInfo");
          sessionStorage.removeItem("userDeptInfo");
          sessionStorage.removeItem("publcKey");

          this.$message({
            type: "success",
            message: "退出成功",
          });
        })
        .catch(() => {});
    },
  },
};
</script>
<style scoped lang="less">
@import url("~@/assets/css/index.less");
.search {
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  .search-wrap {
    width: 600px;
    height: 50px;
    line-height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 1);
    border-radius: 100px;
    .search-img {
      height: 20px;
      line-height: 50px;
      padding: 0 20px;
      margin-top: 3px;
      cursor: pointer;
    }
  }
  /deep/ .el-input {
    height: 50px;
    line-height: 50px;
    padding: 0 !important;
  }
  /deep/.el-input__inner {
    background-color: rgba(0, 0, 0, 0);
    border: none;
    color: #000;
    height: 50px;
    line-height: 50px;
    margin-top: 2px;
  }
  i {
    font-size: 20px;
    color: #2579bf;
    font-weight: bold;
    display: none !important;
  }
}
.header-wrap {
  width: 100%;
  background-color: #2579bf;
}
.specialistHeader.active {
  padding: 0.2em 6em;
  background-color: #2579bf;
}
.specialistHeader {
  width: 12.8em;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  // padding: 0.2em 3em;
  padding-left: 0 !important;
  padding-right: 0 !important;
  padding-top: 0.2em;
  padding-bottom: 0.2em;
  .specialistHeader_img {
    width: 2.42em;
    height: 0.58em;
    cursor: pointer;
    object-fit: contain;
  }
  .hoverBorder:hover{
	border-bottom: 3px solid #fff;
  }
  .active {
    border-bottom: 3px solid #fff;
  }
  div:last-child {
    font-size: 0.13em;
  }
  div {
    cursor: pointer;
    font-size: 16px;
    color: #fff;
    padding: 0.3em 0;
    border-bottom: 3px solid rgba(0, 0, 0, 0);
    a {
      color: #fff;
    }
  }
  .login {
    border-right: 1px solid #fff;

    padding: 0;

    padding-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeadTop.vue